import { Injectable, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators'
import { HttpParams } from '@angular/common/http';
import { TCCPHttpService } from '../../shared/services/tccp-http.service';
import { TCCPConstantValues } from '../../shared/models/tccp-constants';
import { TCCPLoggerService } from '../../shared/services/tccp-logger.service';
import { environment } from '../../../environments/environment';
import { Vehicle } from 'src/modules/shared/models/vehicle';
import { AdminService } from '../admin.service';

@Injectable({
  providedIn: 'root'
})
export class ManageVehicleService {

  constructor(
    private httpService: TCCPHttpService, private logger: TCCPLoggerService, private adminService: AdminService) { }
  private apiUrl: string;
  public appBase = TCCPConstantValues[environment.applicationName];
  public baseURL = this.appBase.Urls;
  public vehicleYear: number;
  public vehicle: Vehicle;
  public features = [];
  public refreshFeatures = new EventEmitter();
  public statusMessage = new EventEmitter();

  /** For service call to get Vehicle
   * @class VehicleService
   * @method getVehicle
   * @param flowName - flow name
   * @returns Observable
   */
  getAllVehicle(): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting vehicle', '');
    const url = this.baseURL['GET_ALL_VEHICLE'] + this.adminService.selectedApplication.toLowerCase();
    return this.httpService.get(url).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting vehicle successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting vehicle failed', '', error);
          return error;
        })
    );
  }

  getVehicle(model: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting vehicle', '');
    const url = this.baseURL['GET_VEHICLE'] + this.adminService.selectedApplication.toLowerCase() + '&model=' + encodeURIComponent(model);
    return this.httpService.get(url).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting vehicle successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting vehicle failed', '', error);
          return error;
        })
    );
  }

  getmodel(): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting year', '');
    return this.httpService.get(this.baseURL['MODEL_URL'] + this.adminService.selectedApplication.toLowerCase()).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting vehicle model successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting vehicle model failed', '', error);
          return error;
        })
        );
  }

  getyear(model: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting year', '');
    return this.httpService.get(this.baseURL['YEAR_URL'] + '?model=' + encodeURIComponent(model) + '&source=' +
      this.adminService.selectedApplication.toLowerCase()).pipe(
        map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting vehicle year successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting vehicle year failed', '', error);
          return error;
        })
      );
  }

  getFeature(model: string, year: number): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting flow', '');
    return this.httpService.get(this.baseURL['GET_VEHICLE'] + this.adminService.selectedApplication.toLowerCase() +
      '&model=' + encodeURIComponent(model) + '&year=' + year).pipe(
        map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow failed', '', error);
          return error;
        })
      );
  }

  /** For service call to update vehicle
    * @class VehicleService
    * @method updateVehicleInfo
    * @param Vehicle Model -Vehicle Model
    * @returns Observable
    */
  updateVehicle(vehicle: Vehicle): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting flow', '');
    const url = this.baseURL['UPDATE_VEHICLE'] + this.adminService.selectedApplication.toLowerCase();
    return this.httpService.put(url, vehicle).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }

  /** For service call to delete vehicle
    * @class VehicleService
    * @method deleteVehicle
    * @param Vehicle Model -Vehicle Model
    * @returns Observable
    */
  deleteVehicle(model: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting flow', '');
    const url = this.baseURL['DELETE_VEHICLE'];
    return this.httpService.delete(url + '?model=' + encodeURIComponent(model) + '&source=' + this.adminService.selectedApplication.toLowerCase()).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }

  /** For service call to update vehicle
   * @class VehicleService
   * @method updateVehicleInfo
   * @param Vehicle Model -Vehicle Model
   * @returns Observable
   */
  createVehicle(vehicle: Vehicle): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting flow', '');
    const url = this.baseURL['UPDATE_VEHICLE'] + this.adminService.selectedApplication.toLowerCase()
    return this.httpService.post(url, vehicle).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow failed', '', error);
          return error;
        })
    )
  }

  /**
   * Function for associating feature to selected vehicle models
   * @param vehicle
   */
  updateVehicles(vehicle: Vehicle[]): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting flow', '');
    const url = this.baseURL.UPDATE_VEHICLES + this.adminService.selectedApplication.toLowerCase();
    return this.httpService.put(url, vehicle).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }


  /**
   * Function for get all vehicles by featureId
   * @param featureId
   */
  getAllVehiclesByFeature(featureId: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting vehicle', '');
    const url = this.baseURL.GET_ALL_VEHICLE_BY_FEATURE + '?source=' +
      this.adminService.selectedApplication.toLowerCase() + '&issueId=' + featureId;
    return this.httpService.get(url).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting vehicle successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting vehicle failed', '', error);
          return error;
        })
    );
  }

}
